import { createContext } from 'react';

import { IChecklistContext } from '@features/Checklist/model/types';

export const ChecklistContext = createContext<IChecklistContext | null>(null);
